import React, { useEffect } from 'react'
import Header from './Header';
import { connect } from 'react-redux';
import { getOrder, removeUserError } from '../redux/actions/user';
import { useParams } from 'react-router-dom';
import { redirectSuccess } from '../redux/actions/cart';
import { orderStatus } from '../redux/reducers/cart';
import { removeTable } from '../redux/actions/table';
import { formatPrice, getNoPaymentMerchantIds, itemNameWithAddons, itemNamewithAddonV1 } from '../common/Functions';

function Order({ getOrder, error, order, redirectSuccess, removeTable, removeUserError }) {


    const params = useParams();
    const orderId = params.id;


    useEffect(() => {
        getOrder(orderId)
        redirectSuccess();
        removeTable();
        return () => {
            removeUserError()
        }
    }, [orderId])


    if (order && order.order_info && order.order_info.payment_type == 'cod') {
        order.order_info.payment_type = 'CASH';
    }



    function convertDate() {
        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let d = new Date(order.order_info.transaction_date);
        return months[d.getMonth()];
    }

    function convertDay() {
        let d = new Date(order.order_info.transaction_date);
        return d.getDate();
    }
    const noPayment = getNoPaymentMerchantIds();


    return (
        <>
            <Header />
            {error && <div className="alert alert-danger" style={{ marginTop: "60px" }}>{error}</div>}
            {order.order_info && <div className="previous-orders-main" style={{ marginTop: "51px" }}>
                <div className="previous-order-list">
                    <div className="previous-order-item">
                        <div className="previous-order-item-head text-white active">
                            <div className="order-date  text-center">
                                <span className="fa fa-calendar"></span>
                                <span className="month-name">{convertDate()}</span>
                                <span className="date font-bold">{convertDay()}</span>
                            </div>
                            <span className="resturant-name">{order.order_info.order_id}</span>

                        </div>
                        <div className="order-content active">
                            <div className="previous-order-info">
                                <div className="completed-order mt-25">
                                    <div className="order-full-details mt-25">
                                        <div className="row font-semibold">
                                            <div className="col-6">Items Ordered:</div>
                                            <div className="col-6 text-right">Amount</div>
                                        </div>
                                        {order.cart.cart_content.map((item, index) => (<div className="row mt-5" key={index}>
                                            <div className="col-6">{item.qty} x {itemNamewithAddonV1(item)}</div>
                                            <div className="col-6 text-right">{formatPrice(item.total)}</div>
                                        </div>))}

                                        <div className="bill-calculations border-top">
                                            <div className="bill-top ">
                                                <div className="row">
                                                    <div className="col-6">Item Total</div>
                                                    <div className="col-6 text-right">{formatPrice(order?.cart?.subtotal?.amount_pretty)} </div>
                                                </div>
                                                {order?.cart?.discount?.map((extra, index) => <div className="row" key={index}>
                                                    <div className="col-6">{extra.type}</div>
                                                    <div className="col-6 text-right">{formatPrice(extra.amount_pretty)}</div>
                                                </div>)}
                                                {order?.cart?.extra?.map((extra, index) => <div className="row" key={index}>
                                                    <div className="col-6">{extra.type}</div>
                                                    <div className="col-6 text-right">{formatPrice(extra.amount_pretty)}</div>
                                                </div>)}
                                            </div>
                                            <div className="grand-total-calculation ">
                                                <div className="row">
                                                    <div className="col-6 font-semibold">Grand Total</div>
                                                    <div className="col-6 text-right font-semibold">{formatPrice(order.cart.grand_total.amount_pretty)}</div>
                                                </div>
                                            </div>
                                            {noPayment.indexOf(order.order_info.merchant_id) == -1 && <div className="payment-details mt-25" >
                                                <h3>Payment Details </h3>
                                                <p className="small">Payment Mode:</p>
                                                <p>{order.order_info.payment_type}</p>
                                            </div>}
                                            {noPayment.indexOf(order.order_info.merchant_id) != -1 && <div className="payment-details mt-25">                                                                                              
                                                <p>Thank you. Someone will assist you with the physical(printed) bill copy!!</p>
                                            </div>}
                                            {/*<div className="card-details mt-10">
                                                <p className="small">Payment Mode:</p>
                                                <p>HDFC Debit Card 3126 7xxxx xxxx xxxx</p>
                                            </div>
                                            <div className="mt-55">
                                                <a className="text-pink" href="#">View bill</a>
    </div>*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

const mapStateToProps = (state) => ({
    error: state.user.error,
    order: state.user.selectedOrder
})
export default connect(mapStateToProps, { getOrder, redirectSuccess, removeTable, removeUserError })(Order)
